(function () {
"use strict";
var $3d28d7f1aac198f5$exports = {};
function $8713978b2328d32b$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}


function $4fc75ccb937ab1df$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $4fc75ccb937ab1df$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}


function $09cbfe85151ea6c6$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return arr;
}


function $8ca2848f896a6803$export$71511d61b312f219(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}


function $a0bc1859061deae1$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $c3b10a83b523f372$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $d4f69c5c6c4654b1$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
}


function $efec029548ccee7f$export$71511d61b312f219(arr, i) {
    return (0, $09cbfe85151ea6c6$export$71511d61b312f219)(arr) || (0, $8ca2848f896a6803$export$71511d61b312f219)(arr, i) || (0, $d4f69c5c6c4654b1$export$71511d61b312f219)(arr, i) || (0, $a0bc1859061deae1$export$71511d61b312f219)();
}



function $c50969dc1df61e8b$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $c3b10a83b523f372$export$71511d61b312f219)(arr);
}


function $09c9f293d010c0e1$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


function $38c2d4931cb7a7c4$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}



function $227c6742e0ff6f82$export$71511d61b312f219(arr) {
    return (0, $c50969dc1df61e8b$export$71511d61b312f219)(arr) || (0, $09c9f293d010c0e1$export$71511d61b312f219)(arr) || (0, $d4f69c5c6c4654b1$export$71511d61b312f219)(arr) || (0, $38c2d4931cb7a7c4$export$71511d61b312f219)();
}


"use strict";
/**
 * This class represents the game.
 * Now it has a basic structure, that is needed for testing.
 * Feel free to add more props and methods if needed.
 */ var $3d28d7f1aac198f5$var$Game = /*#__PURE__*/ function() {
    function Game(initialState) {
        (0, $8713978b2328d32b$export$71511d61b312f219)(this, Game);
        this.size = 4;
        this.board = initialState || [
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ]
        ];
        this.score = 0;
        this.status = "idle"; // 'idle', 'playing', 'win', 'lose'
    }
    (0, $4fc75ccb937ab1df$export$71511d61b312f219)(Game, [
        {
            key: "moveLeft",
            value: function moveLeft() {
                if (this.status !== "playing") return;
                var moved = false;
                for(var row = 0; row < this.size; row++){
                    var originalRow = (0, $227c6742e0ff6f82$export$71511d61b312f219)(this.board[row]);
                    var newRow = [];
                    for(var col = 0; col < this.size; col++)if (this.board[row][col] !== 0) newRow.push(this.board[row][col]);
                    // Злиття плиток
                    var mergedRow = [];
                    for(var i = 0; i < newRow.length; i++)if (newRow[i] === newRow[i + 1]) {
                        mergedRow.push(newRow[i] * 2);
                        this.score += newRow[i] * 2;
                        i++;
                    } else mergedRow.push(newRow[i]);
                    // Заповнення порожніх клітинок нулями
                    while(mergedRow.length < this.size)mergedRow.push(0);
                    // Оновлюємо дошку тільки якщо змінилася
                    if (JSON.stringify(originalRow) !== JSON.stringify(mergedRow)) {
                        this.board[row] = mergedRow;
                        moved = true;
                    }
                }
                // Додаємо випадкову плитку лише якщо дошка змінилася
                if (moved) this.addRandomTile();
            }
        },
        {
            key: "moveRight",
            value: function moveRight() {
                var _this = this, _loop = function(row) {
                    var originalRow = (0, $227c6742e0ff6f82$export$71511d61b312f219)(_this.board[row]);
                    var reversedRow = (0, $227c6742e0ff6f82$export$71511d61b312f219)(originalRow).reverse();
                    var filtered = reversedRow.filter(function(val) {
                        return val !== 0;
                    });
                    var merged = [];
                    for(var i = 0; i < filtered.length; i++)if (filtered[i] === filtered[i + 1]) {
                        merged.push(filtered[i] * 2);
                        _this.score += filtered[i] * 2;
                        i++;
                    } else merged.push(filtered[i]);
                    while(merged.length < _this.size)merged.push(0);
                    var newRow = merged.reverse();
                    if (JSON.stringify(originalRow) !== JSON.stringify(newRow)) {
                        _this.board[row] = newRow;
                        moved = true;
                    }
                };
                if (this.status !== "playing") return;
                var moved = false;
                for(var row = 0; row < this.size; row++)_loop(row);
                if (moved) this.addRandomTile();
            }
        },
        {
            key: "moveUp",
            value: function moveUp() {
                var _this = this, _loop = function(col) {
                    var originalColumn = [];
                    for(var row = 0; row < _this.size; row++)originalColumn.push(_this.board[row][col]);
                    var filtered = originalColumn.filter(function(val) {
                        return val !== 0;
                    });
                    var merged = [];
                    for(var i = 0; i < filtered.length; i++)if (filtered[i] === filtered[i + 1]) {
                        merged.push(filtered[i] * 2);
                        _this.score += filtered[i] * 2;
                        i++;
                    } else merged.push(filtered[i]);
                    while(merged.length < _this.size)merged.push(0);
                    var movedColumn = merged;
                    for(var row1 = 0; row1 < _this.size; row1++){
                        if (_this.board[row1][col] !== movedColumn[row1]) moved = true;
                        _this.board[row1][col] = movedColumn[row1];
                    }
                };
                if (this.status !== "playing") return;
                var moved = false;
                for(var col = 0; col < this.size; col++)_loop(col);
                if (moved) this.addRandomTile();
            }
        },
        {
            key: "moveDown",
            value: function moveDown() {
                var _this = this, _loop = function(col) {
                    var originalColumn = [];
                    for(var row = _this.size - 1; row >= 0; row--)originalColumn.push(_this.board[row][col]);
                    var filtered = originalColumn.filter(function(val) {
                        return val !== 0;
                    });
                    var merged = [];
                    for(var i = 0; i < filtered.length; i++)if (filtered[i] === filtered[i + 1]) {
                        merged.push(filtered[i] * 2);
                        _this.score += filtered[i] * 2;
                        i++; // пропускаємо наступний
                    } else merged.push(filtered[i]);
                    while(merged.length < _this.size)merged.push(0);
                    for(var row1 = _this.size - 1; row1 >= 0; row1--){
                        var newValue = merged[_this.size - 1 - row1];
                        if (_this.board[row1][col] !== newValue) {
                            moved = true;
                            _this.board[row1][col] = newValue;
                        }
                    }
                };
                if (this.status !== "playing") return;
                var moved = false;
                for(var col = 0; col < this.size; col++)_loop(col);
                if (moved) this.addRandomTile();
            }
        },
        {
            /**
   * @returns {number}
   */ key: "getScore",
            value: function getScore() {
                return this.score;
            }
        },
        {
            /**
   * @returns {number[][]}
   */ key: "getState",
            value: function getState() {
                return this.board;
            }
        },
        {
            /**
   * Returns the current game status.
   *
   * @returns {string} One of: 'idle', 'playing', 'win', 'lose'
   *
   * `idle` - the game has not started yet (the initial state);
   * `playing` - the game is in progress;
   * `win` - the game is won;
   * `lose` - the game is lost
   */ key: "getStatus",
            value: function getStatus() {
                if (this.isGameWon()) this.status = "win";
                else if (this.isGameLost()) this.status = "lose";
                else if (this.isGameInProgress()) this.status = "playing";
                else this.status = "idle";
                return this.status;
            }
        },
        {
            /**
   * Starts the game.
   */ key: "start",
            value: function start() {
                this.status = "playing";
                this.addRandomTile();
                this.addRandomTile();
            }
        },
        {
            /**
   * Resets the game.
   */ key: "restart",
            value: function restart() {
                this.board = [
                    [
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0
                    ]
                ];
                this.score = 0;
                this.status = "idle";
                this.start();
            }
        },
        {
            /**
   * Adds a random tile to the board.
   *
   * @returns {number[][]}
   */ key: "addRandomTile",
            value: function addRandomTile() {
                var emptyTiles = this.getEmptyTiles();
                if (emptyTiles.length === 0) return;
                var randomIndex = Math.floor(Math.random() * emptyTiles.length);
                var _emptyTiles_randomIndex = (0, $efec029548ccee7f$export$71511d61b312f219)(emptyTiles[randomIndex], 2), row = _emptyTiles_randomIndex[0], col = _emptyTiles_randomIndex[1];
                this.board[row][col] = Math.random() < 0.9 ? 2 : 4;
                this.score += this.board[row][col];
                this.status = "playing";
            }
        },
        {
            /**
   * Returns the empty tiles on the board.
   *
   * @returns {number[][]}
   */ key: "getEmptyTiles",
            value: function getEmptyTiles() {
                var emptyTiles = [];
                for(var row = 0; row < this.size; row++){
                    for(var col = 0; col < this.size; col++)if (this.board[row][col] === 0) emptyTiles.push([
                        row,
                        col
                    ]);
                }
                return emptyTiles;
            }
        },
        {
            /**
   * Checks if the game is over.
   *
   * @returns {boolean}
   */ key: "isGameOver",
            value: function isGameOver() {
                // Check if there are any empty tiles
                if (this.getEmptyTiles().length > 0) return false;
                // Check if there are any possible moves
                for(var row = 0; row < this.size; row++)for(var col = 0; col < this.size; col++){
                    if (col < this.size - 1 && this.board[row][col] === this.board[row][col + 1] || row < this.size - 1 && this.board[row][col] === this.board[row + 1][col]) return false;
                }
                return true;
            }
        },
        {
            /**
   * Checks if the game is won.
   *
   * @returns {boolean}
   */ key: "isGameWon",
            value: function isGameWon() {
                for(var row = 0; row < this.size; row++)for(var col = 0; col < this.size; col++){
                    if (this.board[row][col] === 2048) return true;
                }
                return false;
            }
        },
        {
            /**
   * Checks if the game is lost.
   *
   * @returns {boolean}
   */ key: "isGameLost",
            value: function isGameLost() {
                return this.isGameOver() && !this.isGameWon();
            }
        },
        {
            /**
   * Checks if the game is in progress.
   *
   * @returns {boolean}
   */ key: "isGameInProgress",
            value: function isGameInProgress() {
                return this.status === "playing";
            }
        }
    ]);
    return Game;
}();
$3d28d7f1aac198f5$exports = $3d28d7f1aac198f5$var$Game;


var $197cd56b15c33885$var$game = new $3d28d7f1aac198f5$exports();
document.addEventListener("keydown", function(e) {
    if ($197cd56b15c33885$var$game.getStatus() === "playing") {
        switch(e.key){
            case "ArrowLeft":
                $197cd56b15c33885$var$game.moveLeft();
                break;
            case "ArrowRight":
                $197cd56b15c33885$var$game.moveRight();
                break;
            case "ArrowUp":
                $197cd56b15c33885$var$game.moveUp();
                break;
            case "ArrowDown":
                $197cd56b15c33885$var$game.moveDown();
                break;
        }
        $197cd56b15c33885$var$renderGame();
    }
});
var $197cd56b15c33885$var$button = document.querySelector(".start");
$197cd56b15c33885$var$button.addEventListener("click", function() {
    if ($197cd56b15c33885$var$game.getStatus() === "playing") {
        $197cd56b15c33885$var$game.restart();
        $197cd56b15c33885$var$renderGame();
        $197cd56b15c33885$var$button.classList.remove("start");
        $197cd56b15c33885$var$button.classList.add("restart");
        $197cd56b15c33885$var$button.textContent = "Restart";
    }
    if ($197cd56b15c33885$var$game.getStatus() === "win") {
        $197cd56b15c33885$var$game.restart();
        $197cd56b15c33885$var$renderGame();
        $197cd56b15c33885$var$button.classList.remove("start");
        $197cd56b15c33885$var$button.classList.add("restart");
        $197cd56b15c33885$var$button.textContent = "Restart";
    }
    if ($197cd56b15c33885$var$game.getStatus() === "lose") {
        $197cd56b15c33885$var$game.restart();
        $197cd56b15c33885$var$renderGame();
        $197cd56b15c33885$var$button.classList.remove("start");
        $197cd56b15c33885$var$button.classList.add("restart");
        $197cd56b15c33885$var$button.textContent = "Restart";
    }
    if ($197cd56b15c33885$var$game.getStatus() === "idle") {
        $197cd56b15c33885$var$game.start();
        $197cd56b15c33885$var$renderGame();
        $197cd56b15c33885$var$button.classList.remove("start");
        $197cd56b15c33885$var$button.classList.add("restart");
        $197cd56b15c33885$var$button.textContent = "Restart";
    }
});
var $197cd56b15c33885$var$renderGame = function() {
    var fieldCells = document.querySelectorAll(".field-cell");
    // Clear the board
    fieldCells.forEach(function(cell) {
        cell.textContent = "";
        cell.classList.remove("field-cell--2");
        cell.classList.remove("field-cell--4");
        cell.classList.remove("field-cell--8");
        cell.classList.remove("field-cell--16");
        cell.classList.remove("field-cell--32");
        cell.classList.remove("field-cell--64");
        cell.classList.remove("field-cell--128");
        cell.classList.remove("field-cell--256");
        cell.classList.remove("field-cell--512");
        cell.classList.remove("field-cell--1024");
        cell.classList.remove("field-cell--2048");
    });
    // Render the game state
    for(var row = 0; row < $197cd56b15c33885$var$game.size; row++)for(var col = 0; col < $197cd56b15c33885$var$game.size; col++){
        var cellIndex = row * $197cd56b15c33885$var$game.size + col;
        var cellValue = $197cd56b15c33885$var$game.board[row][col];
        if (cellValue !== 0) {
            fieldCells[cellIndex].textContent = cellValue;
            fieldCells[cellIndex].classList.add("field-cell");
            fieldCells[cellIndex].classList.add("field-cell--".concat(cellValue));
        }
    }
    // Update score
    document.querySelector(".game-score").textContent = "".concat($197cd56b15c33885$var$game.score);
    var win = document.querySelector(".message-win");
    var lose = document.querySelector(".message-lose");
    var start = document.querySelector(".message-start");
    if ($197cd56b15c33885$var$game.getStatus() === "win") {
        win.classList.remove("hidden");
        lose.classList.add("hidden");
        start.classList.add("hidden");
    }
    if ($197cd56b15c33885$var$game.getStatus() === "lose") {
        win.classList.add("hidden");
        lose.classList.remove("hidden");
        start.classList.add("hidden");
    }
    if ($197cd56b15c33885$var$game.getStatus() === "playing") {
        win.classList.add("hidden");
        lose.classList.add("hidden");
        start.classList.add("hidden");
    }
};

})();
//# sourceMappingURL=index.3e12b78a.js.map
